var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4844 5.43218L16.5687 0.517568C16.4052 0.3541 16.2112 0.224428 15.9977 0.135958C15.7841 0.0474884 15.5552 0.00195313 15.3241 0.00195312C15.0929 0.00195313 14.864 0.0474884 14.6505 0.135958C14.4369 0.224428 14.2429 0.3541 14.0795 0.517568L0.515889 14.0811C0.351753 14.244 0.221621 14.4378 0.133059 14.6514C0.0444964 14.865 -0.000729755 15.094 8.9041e-06 15.3252V20.2409C8.9041e-06 20.7077 0.18543 21.1553 0.515481 21.4854C0.845533 21.8154 1.29318 22.0008 1.75994 22.0008H20.2392C20.4726 22.0008 20.6964 21.9081 20.8615 21.7431C21.0265 21.5781 21.1192 21.3543 21.1192 21.1209C21.1192 20.8875 21.0265 20.6637 20.8615 20.4986C20.6964 20.3336 20.4726 20.2409 20.2392 20.2409H9.16486L21.4844 7.92138C21.6479 7.75795 21.7775 7.56392 21.866 7.35037C21.9545 7.13682 22 6.90793 22 6.67678C22 6.44563 21.9545 6.21674 21.866 6.00319C21.7775 5.78964 21.6479 5.59561 21.4844 5.43218ZM11.4396 5.64557L13.2754 7.4814L3.95986 16.7969L2.12403 14.9611L11.4396 5.64557ZM1.75994 20.2409V17.0851L4.91572 20.2409H1.75994ZM7.03974 19.8768L5.20501 18.041L14.5195 8.72545L16.3553 10.5613L7.03974 19.8768ZM17.5993 9.31723L12.6847 4.40152L15.3246 1.76162L20.2392 6.67733L17.5993 9.31723Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.52e8645d8b30186752d75c20675a4b74.svg";
export { ForwardRef as ReactComponent };